<template>
	<PopupRouterView :showLeftIcon="true" label="Version Notification Input"
		okTitle="Save"
		cancelTitle="Cancel"
		entityName="versionnotification"
		:documentId="mainRecordId"
		@saveMethod="saveAction"
		@hideMethod="onHidden"
		:isBusy="isBusy"
		ref="versionNotificationInput">

		<b-card header="Version Notification" class="mb-3 card-max-width">
			<b-row>
				<b-col cols="12" lg="6">
					<app-input-combobox :options="platformOptions" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Platform" id="platform" size="sm" :model.sync="model.platform" :selected="getOptionName(platformOptions, model.platform)" :isRequired="true" :state="validateState('platform')" :errorMessage="getErrorMessage(errorMessage.platform, 'platform')" />
					<app-input-textbox id="version" label-cols-lg="12" label="Version" label-for="input-version" size="sm" :model.sync="model.version" maxLength="50" :isRequired="true" :state="validateState('version')" :errorMessage="getErrorMessage(errorMessage.version, 'version')" />
					<app-input-combobox :options="modeOptions" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Mode" id="mode" size="sm" :model.sync="model.mode" :selected="getOptionName(modeOptions, model.mode)" :isRequired="true" :state="validateState('mode')" :errorMessage="getErrorMessage(errorMessage.mode, 'mode')" />
					<app-input-textbox id="title-notification" label-cols-lg="12" label="Title Notification" label-for="input-title-notification" size="sm" :model.sync="model.titleNotification" maxLength="200" />
					<app-input-textarea id="message-notification" label-cols-lg="12" label="Message Notification" label-for="input-message-notification" size="sm" :model.sync="model.messageNotification" maxLength="1000" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-textbox id="appstore-url-label" label-cols-lg="12" label="App Store Url" label-for="input-appstore-button-label" size="sm" :model.sync="model.appStoreUrl" maxLength="2000" />
					<app-input-textbox id="playstore-url-label" label-cols-lg="12" label="Play Store Url" label-for="input-playstore-button-label" size="sm" :model.sync="model.playStoreUrl" maxLength="2000" />
					
					<app-input-textbox id="store-button-label" label-cols-lg="12" label="Store Button Label" label-for="input-store-button-label" size="sm" :model.sync="model.storeButtonLabel" maxLength="100" />
					<app-input-textbox id="dismiss-button-label" label-cols-lg="12" label="Dismiss Button Label" label-for="input-dismiss-button-label" size="sm" :model.sync="model.dismissButtonLabel" maxLength="100" />
					<app-input-textbox id="close-button-label" label-cols-lg="12" label="Close Button Label" label-for="input-close-button-label" size="sm" :model.sync="model.closeButtonLabel" maxLength="100" />
				</b-col>
			</b-row>
		</b-card>

		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import VersionNotification from '@/models/VersionNotification/VersionNotification';
import VersionNotificationFilter from '@/filters/VersionNotification/VersionNotificationFilter';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputCombobox from '@/components/AppInputCombobox';
import PopupRouterView from '@/components/PopupRouterView';

export default {
	components : {
		AppInputTextbox,
		AppInputTextarea,
		AppInputCombobox,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			platform: {required},
			version: {required},
			mode: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				platform: { required : "Platform is Required."},
				version: { required : "Version is Required."},
				mode: { required : "Mode is Required."},
			},
			isBusy: false,
			modelId: null,
			model: {},
			filterVersionNotification : null,
			isDataCommited : false,
			mainRecordId : '',
			platformOptions: [
				{ id: 'iOS', name: 'iOS' },
				{ id: 'android', name: 'android' },
			],
			modeOptions: [
				{ id: 'Mandatory', name: 'Mandatory' },
				{ id: 'Optional', name: 'Optional' },
				{ id: 'Expired', name: 'Expired' },
			],
		}
	},
	methods : {
		getVersionNotification : async function(id) {
			this.isBusy = true;
			VersionNotification.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId || result.id);
				this.isBusy = false;
			}).catch(() => { this.isBusy = false; });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.versionNotificationInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			}

			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				VersionNotification.updateData(this, model, id).then(result => {
					this.isDataCommited = true;
					if (result) {
						this.$router.push({ name: 'versionnotificationindex' });
					}
					this.isBusy = false;
				}).catch(() => { this.isBusy = false; });
			} else {
				VersionNotification.createData(this, model).then(result => {
					this.isDataCommited = true;
					if (result) {
						this.$router.push({ name: 'versionnotificationindex' });
					}
					this.isBusy = false;
				}).catch(() => { this.isBusy = false; });
			}
		},
		updateData() {},
		onHidden() {
			this.$router.push({ name: 'versionnotificationindex' });
		},
		getOptionName(options, id) {
			let option = options.find(item => item.id === id);
			return option != null ? option.name : '';
		},
	},
	beforeMount() {
		this.model = new VersionNotification();
		this.filterVersionNotification = new VersionNotificationFilter();
	},
	mounted(){
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getVersionNotification(id);
		} else {
			this.model.platform = 'android';
			this.model.mode = 'Optional';
		}
	},
	watch : {
		'$route.params.id': function(id) {
			if (id != '' && id != null && id != undefined) {
				this.modelId = id;
				this.getVersionNotification(id);
			} else {
				this.modelId = null;
				this.model = new VersionNotification();
				this.model.platform = 'android';
				this.model.mode = 'Optional';
			}
		},
	},
}
</script>
